<template>
  <NavigationComponent>
    <Standardfolie title="src/router/index.js">
      <p>
        Die "routes" legen die URLs fest, unter denen die einzelnen Seiten
        erreichbar sind.
      </p>
      <VCode
        content='...
const routes = [
  {
    path: "/einführung/",
    name: "Einführung",
    component: () => {
      return import("../views/Einführung.vue");
    }
  }
];
...'
      >
      </VCode>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "../components/NavigationComponent";
import Standardfolie from "../components/Standardfolie";
import VCode from "../components/VCode";
export default {
  name: "Router",
  components: { Standardfolie, NavigationComponent, VCode }
};
</script>

<style scoped></style>
